import { LinearAxis, rotateAxis } from './axis';
/**
 * LinearAxis component bind to y scale.
 */
export var AxisY = function AxisY(options) {
  return function () {
    var axisY = LinearAxis(Object.assign({}, {
      crossPadding: 10
    }, options)).apply(void 0, arguments);
    rotateAxis(axisY, options);
    return axisY;
  };
};
AxisY.props = Object.assign(Object.assign({}, LinearAxis.props), {
  defaultPosition: 'left'
});